module.exports = __webpack_public_path__ + "img/1484480055.33196ea0.jpg";